import * as React from 'react'
import { NotificationsSettingsMainConnected } from './NotificationsSettingsMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NotificationsSettingsMainExamples = () => {
  return (
    <div className="NotificationsSettingsMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NotificationsSettingsMainConnected />
      </Provider>
    </div>
  )
}
